import { render, staticRenderFns } from "./comicCard.vue?vue&type=template&id=64328e55"
import script from "./comicCard.vue?vue&type=script&lang=js"
export * from "./comicCard.vue?vue&type=script&lang=js"
import style0 from "./comicCard.vue?vue&type=style&index=0&id=64328e55&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports